var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"custom-on-row-click":()=>{},"entity-name":_vm.$t('changeRecord'),"model":_vm.model,"required-date-value":_vm.dates,"use-date-filter":true,"use-default-action":false,"use-edit-action":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }